/**
 * Set a cookie with a JSON-serialised value and an expiry in days.
 *
 * @param {string} name - Cookie name.
 * @param {*} value - Value to store; will be JSON.stringified.
 * @param {number} [period=1] - Expiration period in days.
 * @returns {void}
 */
export const setCookie = (name, value, period = 1) => {
  try {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + period); // add period days
    const expires = `expires=${currentDate.toUTCString()}`;

    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; ${expires}; path=/;`;
  } catch (error) {
    console.warn('Cookie could not be set'); // eslint-disable-line no-console
  }
};

/**
 * Retrieve and parse a JSON-serialised cookie value.
 *
 * @param {string} name - Cookie name to read.
 * @returns {*|null} Parsed value if present, otherwise `null`.
 */
export const getCookie = (name) => {
  try {
    const nameEQ = `${name}=`;
    const cookie = document.cookie
      .split(';')
      .map(c => c.trim())
      .find(c => c.startsWith(nameEQ));

    return cookie ? JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length))) : null;
  } catch (error) {
    console.warn('Cookie could not be retrieved'); // eslint-disable-line no-console
  }

  return null;
};

/**
 * Delete a cookie by setting its expiration date in the past.
 *
 * @param {string} name - Cookie name to delete.
 * @returns {void}
 */
export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
};

export default function () {
  if (document.querySelector('.valid-cookie-warning')) {
    const cookiesAccepted = window.localStorage.getItem('cookiesAccepted');
    const cookieWarningMessageContainer = document.querySelector('.cookie-warning-messaging');

    if (!cookiesAccepted) {
      cookieWarningMessageContainer.classList.add('d-block');
      cookieWarningMessageContainer.classList.remove('d-none');
    } else {
      cookieWarningMessageContainer.classList.add('d-none');
      cookieWarningMessageContainer.classList.remove('d-block');
      window.__rmcp = [1, 2, 3, 4, 5]; // eslint-disable-line no-underscore-dangle
    }

    document.querySelector('.valid-cookie-warning .btn').addEventListener('click', () => {
      window.localStorage.setItem('cookiesAccepted', 'cookiesAccepted');
      window.__rmcp = [1, 2, 3, 4, 5]; // eslint-disable-line no-underscore-dangle
    });
  }
}
